module.exports = __webpack_public_path__ + "static/media/dashboard-g.04a51e9e.svg";